<template>
  <div class="divLicenceForm">
    <div class="divLicenceBlock">
      <fieldset style="color: black; font-size: 10pt; border: solid 1px black">
        <legend
          style="
            background-color: #5bc0d0;
            color: #da5bb3;
            font-size: 12pt;
            padding: 2px 15px;
            border-radius: 2px;
            height: 35px;
            padding-top: 8px;
          "
        >
          Software Verification Expire : Register with Ekklavya
        </legend>
        <center>
          <table style="width: 100%">
            <tr>
              <td colspan="3" height="50" rowspan="1">
                <span id="lblHeading" style="text-decoration: underline"
                  >Software Verification Key</span
                >
              </td>
            </tr>
            <tr>
              <td rowspan="4">
                <img
                  id="Image1"
                  style="width: 30px"
                  src="../assets/images/toplogo.png"
                />
              </td>
            </tr>
            <tr>
              <td align="left">Send To Ekklavya</td>
              <td align="left">
                <input
                  type="text"
                  readonly="readonly"
                  maxlength="41"
                  style="width: 300px"
                  v-model="licenseInfo.txtSendKey"
                />
              </td>
            </tr>
            <tr>
              <td align="left" style="padding-top: 10px">
                Enter The Software Verification Key
              </td>
              <td style="padding-top: 10px">
                <input
                  type="text"
                  maxlength="41"
                  style="width: 300px"
                  v-model="licenseInfo.txtKey"
                />
              </td>
            </tr>
            <tr>
              <td align="left" style="padding-top: 10px">
                <label>
                  <input
                    type="checkbox"
                    v-model="licenseInfo.checkOTP"
                    v-on:change="submitLicense(true)"
                  />
                  OTP
                </label>
              </td>

              <td
                colspan="2"
                align="center"
                class="CreateLoginBlock"
                style="padding-top: 10px"
              >
                <input
                  type="button"
                  value="Verify Software"
                  style="background-color: #5bc0d0"
                  v-on:click="submitLicense(false)"
                />
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <br />
                <br />
                <br />
                <hr />
              </td>
            </tr>
            <tr>
              <td align="center" colspan="3">
                <span style="color: darkred">{{
                  licenseInfo.labelErrMsg
                }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <hr />
              </td>
            </tr>
            <tr>
              <td colspan="3" align="center" rowspan="10">
                Enter the Software Verification Key provided by ekklavya infosys
                All right reserved.
                <br />
                Copyright 2020
              </td>
            </tr>
          </table>
        </center>
      </fieldset>
    </div>
  </div>
</template>

<script>
import vue from "vue";
import Router from "vue-router";
import config from "@/router/globalConfig";
import LicenseJS from "./serviceJS/licenseJS.js";
export default {
  name: "License",
  components: {},
  data() {
    return {
      licenseInfo: Object,
    };
  },
  methods: {
    getLicense() {
      LicenseJS.GetLicense().then(
        (response) => {
          this.licenseInfo = response.data;
        },
        (error) => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        (failure) => {
          alert("Failure: " + failure);
        }
      );
    },
    submitLicense(isOTP) {
      if (isOTP) {
        this.licenseInfo.ischkOTPClick = true;
      }
      let params = this.licenseInfo;
      LicenseJS.SubmitLicense(params).then(
        (result) => {
          this.licenseInfo = result.data;
          if (isOTP == false && this.licenseInfo.nResult == 1) {
            this.$router.push({ name: "Login" });
          }
        },
        (error) => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        (failure) => {
          alert("Failure: " + failure);
        }
      );
    },
  },
  mounted() {
    this.getLicense();
  },
};
</script>
<style scoped>
html,
body {
  width: 100%;
  height: 100%;
  padding: 0px;
  margin: 0px;
  overflow: hidden;
}

body {
  background: rgb(193, 222, 243) !important;
}
.divLicenceForm {
  width: 100vw;
  height: 100vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgb(193, 222, 243) !important;
}
.divLicenceBlock {
  display: inline-block;
  width: 600px;
  height: 350px;
  margin-top: -50px;
}
@@media screen and (max-width:800px) {
  .divLicenceBlock {
    display: block;
    overflow: auto;
    width: calc(100vw - 20px);
    height: calc(100vh - 20px);
    margin-top: 0px;
  }
}
@@media screen and (max-width:460px) {
  .divLicenceBlock {
    height: auto;
  }
  .divLicenceBlock table tr {
    display: flex;
    flex-wrap: wrap;
  }
  .divLicenceBlock table tr td {
    display: block;
    width: 100%;
    flex-grow: 1;
    flex-shrink: 1;
    padding: 5px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/License.vue